// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js??ref--6-2!./dealger.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../node_modules/vue-style-loader/lib/addStylesClient.js")("72ee3af9", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./static/dealger.css
// module id = 192
// module chunks = 1 2